@if (operation?.config) {
<tec-collapse [title]="`WORKFLOWS.FORM.OPERATIONS.${operation?.type}` | translate" [badge]="index.toString()">
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath()"
        titleKey="WORKFLOWS.CURL_MODAL.TITLE_OPERATION"
    />
    <tec-tile
        [title]="'WORKFLOWS.FORM.OPERATIONS.FINANCIAL_EVALUATION_METHODS' | translate"
        [subtitle]="'WORKFLOWS.DETAIL.FINANCIAL_EVALUATION_METHODS_DESCRIPTION' | translate"
    >
        <div class="grid grid-i2">
            @for (op of operation.config.operations; track $index) {
                @if (op.config['type'] === CONNECTION_TYPE.BANK_SCORING) {
                <tec-card-select
                    [tagImg]="{ icon: 'icon-bank', status: 'notice' }"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_BANK_SCORING' | translate"
                    [description]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_BANK_SCORING_DESCRIPTION' | translate"
                    [tags]="[{ label: 'WORKFLOWS.DETAIL.AUTOMATIC' | translate | uppercase, status: 'success' }]"
                    [selected]="true"
                    [disabled]="true"
                />
                }

                @if (op.config['type'] === CONNECTION_TYPE.WORK_LIFE) {
                <tec-card-select
                    [tagImg]="{ icon: 'icon-briefcase', status: 'control' }"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_WORKLIFE' | translate"
                    [description]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_WORKLIFE_DESCRIPTION' | translate"
                    [tags]="[{ label: 'WORKFLOWS.DETAIL.AUTOMATIC' | translate | uppercase, status: 'success' }]"
                    [selected]="true"
                    [disabled]="true"
                />
                }

                @if (op.config['type'] === CONNECTION_TYPE.IRPF) {
                <tec-card-select
                    [tagImg]="{ icon: 'icon-file' }"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_IRPF' | translate"
                    [description]="'WORKFLOWS.FORM.OPERATIONS.CONNECTION_IRPF_DESCRIPTION' | translate"
                    [tags]="[{ label: 'WORKFLOWS.DETAIL.AUTOMATIC' | translate | uppercase, status: 'success' }]"
                    [selected]="true"
                    [disabled]="true"
                />
                }
            }
        </div>
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate">
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED_TOOLTIP' | translate"
        >
            <tec-badge [label]="'3'" type="square" />
        </tec-info-group>
    </tec-tile>
</tec-collapse>
}
